import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface IHttpOptions {
  headers?:
    | HttpHeaders
    | {
        [header: string]: string | string[];
      };
  body?: any;
  observe?: 'body';
  params?:
    | HttpParams
    | {
        [param: string]: string | string[] | number;
      };
  reportProgress?: boolean;
  responseType?: 'json';
  withCredentials?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class HttpClientService {
  constructor(private httpClient: HttpClient) {}

  private createHeaders(): IHttpOptions {
    return { headers: { 'If-Match': '*' } };
  }

  get<T>(url: string): Observable<T> {
    return this.httpClient.get<T>(url);
  }

  post<I, T>(url: string, body: I): Observable<T> {
    return this.httpClient.post<T>(url, body, this.createHeaders());
  }

  put<I, T>(url: string, body: I): Observable<T> {
    return this.httpClient.put<T>(url, body, this.createHeaders());
  }

  patch<I, T>(url: string, body: I): Observable<T> {
    return this.httpClient.patch<T>(url, body, this.createHeaders());
  }

  delete<T>(url: string): Observable<T> {
    return this.httpClient.delete<T>(url, this.createHeaders());
  }
}
